var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout", { attrs: { showBreadCrumb: false } }, [
    _c("div", { staticClass: "home-page" }, [
      _vm.homeTitle
        ? _c("section", { staticClass: "container-fluid home-page__header" }, [
            _c("div", {
              staticClass: "page-description",
              domProps: { innerHTML: _vm._s(_vm.homeTitle) },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "home-page-content d-flex flex-column" },
        [
          _c("news-highlight", {
            class: `order-${_vm.newsOrder}`,
            attrs: {
              title: _vm.newsSettings.title,
              classTitle: "",
              viewMore: true,
            },
          }),
          _vm._v(" "),
          _c("dashboard-list", {
            staticClass: "container-fluid home-page__modules",
            class: `order-${_vm.modulesOrder}`,
            attrs: {
              listClass: "col-sm-6 col-xxl-4",
              title: _vm.modulesSettings.title,
              listBackoffice: false,
              listInactive: false,
              limit: _vm.modulesSettings.limit,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }